export default __webpack_public_path__ + "static/chart-exploratory-endpoint-03b7b549c49476d1d173b7f0cf2c2c02.png";